import * as yup from 'yup';

const userSettingObjectSchema = yup.object();

export const ValidateUserSettingObject = (value) => {
  userSettingObjectSchema.validateSync(value);
};
